import React from "react";

/**
 * Landing CTA. Renders an <a> when `href` is set, otherwise a <button>.
 *
 * All variants are >=44px tall (min-h-11) to meet the touch-target minimum and
 * carry a visible focus ring — never remove it.
 */

const BASE =
  "inline-flex min-h-11 cursor-pointer items-center justify-center gap-2 " +
  "rounded-lg px-5 py-3 text-base font-medium transition-colors duration-150 " +
  "ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary " +
  "focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50";

const VARIANTS = {
  // 5.4:1 white-on-primary — passes AA for body text.
  primary: "bg-primary text-white hover:bg-blue-700",
  secondary:
    "border border-line bg-white text-black-landing hover:bg-gray-landing",
  // For use on the dark (#121233) bands.
  inverse: "bg-white text-black-landing hover:bg-gray-landing",
  ghost: "text-black-landing hover:bg-gray-landing",
};

export default function Button({
  variant = "primary",
  href,
  children,
  className = "",
  ...rest
}) {
  const classes = `${BASE} ${VARIANTS[variant] || VARIANTS.primary} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} {...rest}>
      {children}
    </button>
  );
}
